import AbstractDialog from '@maison/wrappers/AbstractDialog';

export default class Panel extends AbstractDialog {
  constructor(element, options = {}) {
    super('panel', element, options);
  }
}
